import { render } from "./PackingOptionsContainer.vue?vue&type=template&id=d05114e6"
import script from "./PackingOptionsContainer.vue?vue&type=script&lang=js"
export * from "./PackingOptionsContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__